import React, { useState, useEffect } from 'react';
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fontsource/poppins';
import './../css/Style.css';
import OtpInput from 'react-otp-input';
import {validateEmail, setUtmSource} from "../common/commonFuntion";
import otpnjTimer from './../images/otpnj-timer.svg';
import openEmail from './../images/open-email.png';
import openOtpEmail from './../images/otp-email.png';
import { Modal, Button, Form } from 'react-bootstrap';
import UserService from "../services/UserService";
import PageLoader from './PageLoader';
import { toast } from 'react-toastify';


const OtpTime = 30;

const MailVerify = ({ show, handleClose }) => {
  const userInfo = JSON.parse(sessionStorage.getItem('orderDetails')) || {
    customerName: '',
    mobile: '',
    address: '',
    email: '',
  };

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(OtpTime);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Toast notifications
    const defultAlert = (msg) => toast.warn(msg || "Some network issues, Please try again", { position: "top-center" });
    const notFound = () => toast.warn("Some network issues, Please try again", { position: "top-center" });
    const emailUpdated = () => toast.success("Email has been updated", { position: "top-center" });
    const emailIdNotValid = () => toast.warn("Please enter a valid email", { position: "top-center" });
    const networkIssue = () => toast.warn("Some network issue, Please try again!", { position: "top-center" });
    const enterEmail = () => toast.warn("Please enter your email Id", { position: "top-center" });


  useEffect(() => {
    let countdown;
    if (otpSent && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(countdown);
  }, [otpSent, timer]);

  const handleChange = (otp) => setOtp(otp);

  const handleSendOtp = async (e) => {
    e.preventDefault();
    const validationError = await validateEmail(email);
    if (validationError) {
      setError(validationError);
    } else {
      const res = await saveEmail(email);
      console.log("res === ", res);
      if(res){
        setError("");
        setOtpSent(true);
        setTimer(OtpTime); // Reset the timer
      }
    }
  };

  const saveEmail = async (emailId) =>{
      setLoading(true);
      try {
        const otpResponse = await UserService.generateFreshEamilOtp(emailId, "SSP");
  
        if (otpResponse?.success) {
          setError("");
          setLoading(false);
          return true;
  
        }else if(otpResponse?.message){
          if(otpResponse.message === "Email already registered"){
            setError( <>An account already exists with this email address. Please use a different email or log in using your mobile number.</>);
          }else{
            setError(otpResponse.message);
          }
          setLoading(false);
          return false;
        }
        else{
          setError(`${otpResponse.message || "Something went wrong"}`);
          setLoading(false);
          return false;
        }
  
      } catch (error) {
        console.error("Error in checkMobileExistWithEvent:", error);
        setError(error);
        setLoading(false);
        return false;
      }
  
  }

  const handleValidateOtp = async () => {
      try {
          const response = await UserService.verifiyOtpFresh(otp, email, "SSP");

          if (response && response.data) {
              setOtp('');
              setError("");
              updateEmailAddress();
              // let utmParams = setUtmSource("utm_source");
              // window.location = `/?msg=newCustomer&utm_source=Corporate&${utmParams}`;
          } else if (!response.success) {
              setError(response.message || "Invalid OTP. Please try again.");
              sessionStorage.removeItem("stg_otpEmailValidated");
          } else {
              setError("Something went wrong. Please try again.");
              sessionStorage.removeItem("stg_otpEmailValidated");
          }
      } catch (err) {
          console.error("Error in validateAndHandleOtp:", err);

          if (err.response && err.response.data) {
              if (err.response.status === 429) {
                  setError(
                      "You have entered incorrect OTP multiple times. Please try after 30 minutes."
                  );
              } else {
                  setError(err.response.data.message || "Something went wrong!");
              }
          } else {
              setError("Something went wrong!");
          }

          sessionStorage.removeItem("stg_otpEmailValidated");
      }
  };

  const updateOrderSession = (emaiId) => {
    // Get the current session value (JSON string)
    let orderDetailsOnly = sessionStorage.getItem('orderDetails');

    // Parse the string to convert it into an object
    if (orderDetailsOnly) {
       orderDetailsOnly = JSON.parse(orderDetailsOnly);

       // Modify the specific key (e.g., update age)
       if(emaiId){
          orderDetailsOnly.email = emaiId;

          // Save the updated object back to sessionStorage
          sessionStorage.setItem('orderDetails', JSON.stringify(orderDetailsOnly));
          // console.log("Updated session value:", updatedOrders);
       }
    }
  };


  // Update email address
  const updateEmailAddress = async() => {
    setLoading(true);
    if (email !== "") {
      const mobile = userInfo.mobile;
      UserService.updateEmail(email, mobile)
        .then( async(response) => {
          if (response.data.success) {
            // corporateAccount(email);
            updateOrderSession(email);
            setLoading(false);
            handleClose(email);
            emailUpdated();
          } else {
            setLoading(false);
            emailIdNotValid();
          }
        })
        .catch((err) => {
          setLoading(false);
          if(err?.response?.data?.message){
            defultAlert(err?.response?.data?.message);
          }else{
            notFound();
          }
        });
    } else {
      setLoading(false);
      enterEmail();
    }
  };

  const handleResendOtp = () => {
    setTimer(OtpTime);
    saveEmail(email);
  };

  const handleGoBack = () => {
    setOtpSent(false);
    // setEmail("");
    setOtp("");
    setError("");
  };

  const handleCloseOtp = (status) => {
    handleClose();
    setOtp("");
    setError("");
  };

  return (
    <Modal show={show} onHide={() => handleCloseOtp(false)} centered className="custom-modal-width">
      { loading && <PageLoader/> }
      <Modal.Header className="bg-corporate" closeButton />
      <div className="bg-corporate d-flex justify-content-center pb-3"><img className="img-widht-10" src={otpSent ? openOtpEmail: openEmail} /></div>
      <Modal.Body>
        {!otpSent ? (
          <div className="d-flax text-center">
            <h4 className="alert-heading corporate-title">Email Verification</h4>
            <Form.Group controlId="formBasicOTP" style={{ marginBottom: "2px", display: "grid", justifyItems: "center" }}>
              <Form.Label className="otp-label">
                Please enter your email Id
              </Form.Label>
              <input
                className="form-control"
                type="email"
                name='email'
                id='email'
                placeholder="Enter your email Id"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ padding: "8px", width: "70%" }}
              />
            </Form.Group>
            {error && <p className="emailError">{error}</p>}
            <div className="corporate-otp-btn d-flex justify-content-center">
            <Button
              disabled={!email}
              variant="primary"
              onClick={handleSendOtp}
              style={{ marginTop: "15px" }}
            >
              Send OTP
            </Button>
            </div>
          </div>
        ) : (
          <>
          <div className="d-flax text-center">
            <h4 className="alert-heading corporate-title">Email OTP Verification</h4>
            <p className="sub-title">
              Enter the OTP you received at{" "}
              <span className="phone-number">{email}</span>
            </p>
            <Form.Group className="ooo" controlId="formBasicOTP">
              <div className="d-flex justify-content-between">
              <Form.Label className="otp-label">Enter 4-digit OTP</Form.Label>
              {timer ? (
                <div className="label-next text-right">
                  <img
                    src={otpnjTimer}
                    height="20px"
                    width="15px"
                    className="mr-1"
                    alt="Timer"
                  />
                  00:{timer < 10 ? `0${timer}` : timer}
                </div>
              ) : (
                <div className="label-next text-right">
                  <a onClick={handleResendOtp} className="text-right">
                    Resend OTP
                  </a>
                </div>
              )}
              </div>
              <div className="d-flex justify-content-center">
              <OtpInput
                value={otp}
                onChange={handleChange}
                numInputs={4}
                inputType="number"
                shouldAutoFocus={true}
                renderSeparator={<span> ---- </span>}
                containerStyle={{}}
                renderInput={(props) => <input {...props} 
                  autoComplete="one-time-code"
                  className="otp-input-b"
                  style={{
                    width: "5em",
                    height: "3em",
                    textAlign: "center",
                    background: "#FFFFFF 0% 0% no-repeat padding-box",
                    border: "1px solid #CDCDCD",
                    borderRadius: "8px",
                  }}
                />}
              />
              </div>
            </Form.Group>
            {error && <p style={{ color: "red" }}>{error}</p>}
            <div className="corporate-otp-btn">
              <Button
                variant="primary"
                onClick={handleGoBack}
              >
                Change Email
              </Button>
              <Button
                disabled={otp.length !== 4}
                variant="primary"
                onClick={handleValidateOtp}
              >
                Validate OTP
              </Button>
            </div>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default MailVerify;
